import axios, { AxiosRequestConfig } from "axios";
import { Acao, CreateAcao, EmpresaFabricante, UpdateAcao } from "../types/acao";

export const getAcoes = async (token: string): Promise<Acao[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/acao`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ações:", error);
    throw error;
  }
};

export const getAcaoById = async (token: string, id: string): Promise<Acao> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/acao/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ação:", error);
    throw error;
  }
};

export const createAcao = async (token: string, acaoData: CreateAcao) => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/acao`;

  const response = await axios.post(url, acaoData, config);
  return response.data;
};

export const updateAcao = async (
  token: string,
  id: string,
  acaoData: UpdateAcao
) => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/acao/${id}`;
  const response = await axios.put(url, acaoData, config);
  return response.data;
};

export const deleteAcao = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/acao/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir ação:", error);
    throw error;
  }
};

export const getEmpresasFabricantes = async (
  token: string
): Promise<EmpresaFabricante[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa/fabricas`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresas:", error);
    throw error;
  }
};

export const transferirModelos = async (
  token: string,
  origemId: number,
  destinoId: number,
  modelos: number[]
) => {
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const url = `${process.env.REACT_APP_API_DOMAIN}/manager/import/${origemId}/${destinoId}`;
  const response = await axios.post(url, { modelos }, config);
  return response.data;
};
